import { CategoryForm } from '@/dto/responseDto/category';
import httpAdmin from '@/httpCommon/axiosClient';
class CategoryService {
    create = async (body: CategoryForm) => {
        const res = await httpAdmin.post('dich_vu/danh_muc', body);
        return res?.data;
    };
    getAll = async (params?: any) => {
        const res = await httpAdmin.get('dich_vu/danh_muc', { params });
        return res?.data;
    };
    findById = async (id: string | undefined) => {
        const res = await httpAdmin.get(`dich_vu/danh_muc/${id}`);
        return res?.data;
    };
    update = async (id: string | undefined, body: CategoryForm) => {
        const res = await httpAdmin.put(`dich_vu/danh_muc/${id}`, body);
        return res?.data;
    };
    updateBulk = async (body: CategoryForm[]) => {
        const res = await httpAdmin.put(`dich_vu/danh_muc`, body);
        return res?.data;
    };
    delete = async (id: string) => {
        const res = await httpAdmin.delete(`dich_vu/danh_muc/${id}`);
        return res?.data;
    };
    getCategory = async (params: any) => {
        const res = await httpAdmin.get('dich_vu/danh_muc', { params });
        return res?.data?.data;
    };
}
export default new CategoryService();
